import {
  getSelectOptionsForTools,
  getSelectOptionsForGrades,
  getSelectOptionsForPeople,
  getSelectOptionsForSchools,
  getSelectOptionsForDepartments
} from './selectOptionsHelpers.js';

import {isStaff} from './commonHelpers.js';
import {renderEl, unRenderEl} from './formRender.js';

export function renderSelectSchool(state) {
  const $el = window.$schoolSelect;
  const options = getSelectOptionsForSchools(state);

  renderEl($el, options, state.schools.selected);
}

export function renderSelectPeople(state) {
  const $el = window.$personSelect;
  const options = getSelectOptionsForPeople(state);
  
  
  // 2025-01-09 Modified by Marc Audet
  // See if there is a teacher ID in url and use it to select the value in the dropdown menu
  console.log("renderSelectPeople");
  
  const theParams = new URL(document.location.href).searchParams;
  const hasPerson = theParams.has('person');
  const thePerson = theParams.get('person');
  
  if (hasPerson && thePerson.length>0) 
  {
      console.log("renderSelectPeople.thePerson: "+thePerson);
      renderEl($el, options, thePerson);
  }
  else
  {
      renderEl($el, options, state.people.selected);
  }

}

export function renderSelectTools(state) {
  const $el = window.$toolSelect;

  if (state.people.selected) {
    const options = getSelectOptionsForTools(state);
    renderEl($el, options, state.tools.selected);
  } else {
    unRenderEl($el);
  }
}

export function renderSelectDepartments(state) {
  const $el = window.$departmentSelect;

  if (state.departments.options.length) {
    const options = getSelectOptionsForDepartments(state);

    renderEl($el, options, state.departments.selected);
  } else {
    unRenderEl($el);
  }
}

export function renderSelectGrades(state) {
  const $el = window.$gradeSelect;

  if (state.grades.options.length) {
    const options = getSelectOptionsForGrades(state);

    renderEl($el, options, state.grades.selected);
  } else {
    unRenderEl($el);
  }
}

export function renderInputJobTitle({people}) {
  const $el = window.$jobTitleInput;

  if (isStaff(people.selected)) {
    renderEl($el);
  } else {
    unRenderEl($el);
  }
}

export function renderToolLabel({tools}) {
  const $el = $('#toolLabelForToolPreview');

  if (tools.selected) {
    const link = 'index.php/tool_previewer/tool_preview/' + tools.selectedLabel;

    $el.attr('href', link);
    $el.attr('target', '_blank');
    $el.text('Tool Preview');
  } else {
    const link = window.location.hash || window.location.href.slice(-1) === '#'
      ? window.location.href
      : window.location.href + '#';

    $el.attr('href', link);
    $el.removeAttr('target');
    $el.text('Select Tool To Preview');
  }
}
